<script lang="ts" setup>
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { useLoadingScreen } from '@nxtpeople/nxt-styles';
import { ModuleKey } from '@nxtpeople/nxt-vue-library';

//#region Loading Screen
const { isPending } = useKeycloak();
const { showLoadingScreen, animationComplete } = useLoadingScreen(isPending);
//#endregion
</script>

<template>
   <div :class="'app'">
      <Transition name="fade" mode="out-in">
         <NxtLoadingScreen v-if="showLoadingScreen" :module-key="ModuleKey.NxtPeople" @animation-complete="animationComplete = true" />

         <RouterView v-else />
      </Transition>
   </div>
</template>

<style src="@nxtpeople/nxt-styles/dist/style.css"></style>

<style lang="scss">
@import '../node_modules/bootstrap/scss/functions';
@import '../node_modules/bootstrap/scss/variables';
@import '../node_modules/bootstrap/scss/variables-dark';
@import '../node_modules/bootstrap/scss/maps';
@import '../node_modules/bootstrap/scss/mixins';
@import '../node_modules/bootstrap/scss/root';
@import '../node_modules/bootstrap/scss/bootstrap-grid';
@import '../node_modules/bootstrap/scss/bootstrap-utilities';

.app {
   height: 100vh;
}
</style>
